"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkForScopedNodeAfter = exports.validateClassScoping = exports.namespaceClass = exports.addClass = exports.getAll = exports.get = exports.hooks = exports.diagnostics = void 0;
const feature_1 = require("./feature");
const diagnostics_1 = require("./diagnostics");
const STSymbol = __importStar(require("./st-symbol"));
const STGlobal = __importStar(require("./st-global"));
const resolve_1 = require("../helpers/resolve");
const namespace_1 = require("../helpers/namespace");
const escape_1 = require("../helpers/escape");
const selector_1 = require("../helpers/selector");
const custom_state_1 = require("../helpers/custom-state");
const deprecation_1 = require("../helpers/deprecation");
exports.diagnostics = {
    INVALID_FUNCTIONAL_SELECTOR: diagnostics_1.generalDiagnostics.INVALID_FUNCTIONAL_SELECTOR,
    UNSCOPED_CLASS(name) {
        return `unscoped class "${name}" will affect all elements of the same type in the document`;
    },
    EMPTY_ST_GLOBAL() {
        return `-st-global must contain a valid selector`;
    },
    UNSUPPORTED_MULTI_SELECTORS_ST_GLOBAL() {
        return `unsupported multi selector in -st-global`;
    },
    // -st-extends
    IMPORT_ISNT_EXTENDABLE() {
        return 'import is not extendable';
    },
    CANNOT_EXTEND_UNKNOWN_SYMBOL(name) {
        return `cannot extend unknown symbol "${name}"`;
    },
    CANNOT_EXTEND_JS() {
        return 'JS import is not extendable';
    },
    UNKNOWN_IMPORT_ALIAS(name) {
        return `cannot use alias for unknown import "${name}"`;
    },
};
// HOOKS
exports.hooks = (0, feature_1.createFeature)({
    analyzeSelectorNode({ context, node, rule }) {
        if (node.nodes) {
            // error on functional class
            context.diagnostics.error(rule, exports.diagnostics.INVALID_FUNCTIONAL_SELECTOR(`.` + node.value, `class`), {
                word: (0, selector_1.stringifySelector)(node),
            });
        }
        addClass(context, node.value, rule);
    },
    transformResolve({ context }) {
        const resolvedSymbols = context.getResolvedSymbols(context.meta);
        const locals = {};
        for (const [localName, resolved] of Object.entries(resolvedSymbols.class)) {
            const exportedClasses = [];
            let first = true;
            // collect list of css classes for exports
            for (const { meta, symbol } of resolved) {
                if (!first && symbol[`-st-root`]) {
                    // extended stylesheet root: stop collection as root is expected to
                    // be placed by inner component, for example in <Button class={classes.primaryBtn} />
                    // `primaryBtn` shouldn't contain `button__root` as it is placed by the Button component
                    break;
                }
                first = false;
                if (symbol[`-st-global`]) {
                    // collect global override just in case of
                    // compound set of CSS classes
                    let isOnlyClasses = true;
                    const globalClasses = symbol[`-st-global`].reduce((globalClasses, node) => {
                        if (node.type === `class`) {
                            globalClasses.push(node.value);
                        }
                        else {
                            isOnlyClasses = false;
                        }
                        return globalClasses;
                    }, []);
                    if (isOnlyClasses) {
                        exportedClasses.push(...globalClasses);
                    }
                    continue;
                }
                if (symbol.alias && !symbol[`-st-extends`]) {
                    continue;
                }
                exportedClasses.push((0, namespace_1.namespace)(symbol.name, meta.namespace));
            }
            const classNames = (0, escape_1.unescapeCSS)(exportedClasses.join(' '));
            if (classNames) {
                locals[localName] = classNames;
            }
        }
        return locals;
    },
    transformSelectorNode({ context, selectorContext, node }) {
        const { originMeta, resolver } = selectorContext;
        const resolvedSymbols = context.getResolvedSymbols(context.meta);
        const resolved = resolvedSymbols.class[node.value] || [
            // used to namespace classes from js mixins since js mixins
            // are scoped in the context of the mixed-in stylesheet
            // which might not have a definition for the mixed-in class
            { _kind: 'css', meta: originMeta, symbol: { _kind: 'class', name: node.value } },
        ];
        selectorContext.setCurrentAnchor({ name: node.value, type: 'class', resolved });
        const { symbol, meta } = (0, resolve_1.getOriginDefinition)(resolved);
        if (selectorContext.originMeta === meta && symbol[`-st-states`]) {
            // ToDo: refactor out to transformer validation phase
            (0, custom_state_1.validateRuleStateDefinition)(selectorContext.rule, context.meta, resolver, context.diagnostics);
        }
        namespaceClass(meta, symbol, node, originMeta);
    },
    transformJSExports({ exports, resolved }) {
        Object.assign(exports.classes, resolved);
    },
});
// API
function get(meta, name) {
    return STSymbol.get(meta, name, `class`);
}
exports.get = get;
function getAll(meta) {
    return STSymbol.getAllByType(meta, `class`);
}
exports.getAll = getAll;
function addClass(context, name, rule) {
    if (!STSymbol.get(context.meta, name, `class`)) {
        let alias = STSymbol.get(context.meta, name);
        if (alias && alias._kind !== 'import') {
            alias = undefined;
        }
        STSymbol.addSymbol({
            context,
            symbol: {
                _kind: 'class',
                name,
                alias,
            },
            node: rule,
            safeRedeclare: !!alias,
        });
        // deprecated
        (0, deprecation_1.ignoreDeprecationWarn)(() => {
            context.meta.classes[name] = STSymbol.get(context.meta, name, `class`);
        });
    }
    return STSymbol.get(context.meta, name, `class`);
}
exports.addClass = addClass;
function namespaceClass(meta, symbol, node, // ToDo: check this is the correct type, should this be inline selector?
originMeta) {
    if (`-st-global` in symbol && symbol[`-st-global`]) {
        // change node to `-st-global` value
        const flatNode = (0, selector_1.convertToSelector)(node);
        const globalMappedNodes = symbol[`-st-global`];
        flatNode.nodes = globalMappedNodes;
        // ToDo: check if this is causes an issue with globals from an imported alias
        STGlobal.addGlobals(originMeta, globalMappedNodes);
    }
    else {
        node = (0, selector_1.convertToClass)(node);
        node.value = (0, escape_1.namespaceEscape)(symbol.name, meta.namespace);
    }
}
exports.namespaceClass = namespaceClass;
function validateClassScoping({ context, classSymbol, locallyScoped, reportUnscoped, node, nodes, index, rule, }) {
    if (!classSymbol.alias) {
        return true;
    }
    else if (locallyScoped === false) {
        if (checkForScopedNodeAfter(context, rule, nodes, index) === false) {
            if (reportUnscoped) {
                context.diagnostics.warn(rule, exports.diagnostics.UNSCOPED_CLASS(node.value), {
                    word: node.value,
                });
            }
            return false;
        }
        else {
            return true;
        }
    }
    return locallyScoped;
}
exports.validateClassScoping = validateClassScoping;
// ToDo: support more complex cases (e.g. `:is`)
function checkForScopedNodeAfter(context, rule, nodes, index) {
    for (let i = index + 1; i < nodes.length; i++) {
        const node = nodes[i];
        if (!node) {
            // ToDo: can this get here???
            break;
        }
        if (node.type === 'combinator') {
            break;
        }
        if (node.type === 'class') {
            const name = node.value;
            const classSymbol = addClass(context, name, rule);
            if (classSymbol && !classSymbol.alias) {
                return true;
            }
        }
    }
    return false;
}
exports.checkForScopedNodeAfter = checkForScopedNodeAfter;
//# sourceMappingURL=css-class.js.map